<script>
	import { Router, Link, Route } from "svelte-routing";
	import PlayerView from "./components/playerView.svelte";
	import AdminView from "./components/adminView.svelte";
</script>

<main>
	<PlayerView isAdmin={window.location.href.indexOf("admin") > -1}/>
</main>

<style>
	@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");
	@import url("https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap");

	:global(:root) {
		background-color: #f8f8ff;

		--green: #32CD32;
		--red: #DC143C;
		--gold: #d3af37;

		--font-family: 'Montserrat', sans-serif;
		--font-family-mono: 'Source Code Pro', monospace;
		--font-color: #000000;
	}

	main {
		text-align: center;
		padding: 1em;
		width: 90%;
		max-width: 1280px;
		margin: 0 auto;

		font-family: var(--font-family);
		font-size: 16px;
		color: var(--font-color);
	}
</style>